var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-networks-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var step = ref.step;
    var patchStep = ref.patchStep;
    var goNextStep = ref.goNextStep;
    var goPreviousStep = ref.goPreviousStep;
    var isPreview = ref.isPreview;
    var isLoading = ref.isLoading;
    var isCompletingBrief = ref.isCompletingBrief;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var forceReloadContact = ref.forceReloadContact;
return [_c('activation-brief-networks-view',{attrs:{"brief":brief,"contact":contact,"step":step,"is-loading":isLoading,"is-completing-brief":isCompletingBrief,"error-message":errorMessage},on:{"load-contact":forceReloadContact,"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }